import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS_INTERNA } from '../../config/config';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AffiContrModel } from 'src/app/models/affiliatecontrol.model';

@Injectable({
  providedIn: 'root'
})
export class AffiliateControllService {

  constructor(public http: HttpClient, public router: Router) { }

  postAffiliateControl(affiContrModel: AffiContrModel): Observable<any> {
    const url = URL_SERVICIOS_INTERNA + 'api/AffiliateControl/AffiliateControl_Insert';
    return this.http.post( url, affiContrModel)
      .pipe(map( (resp: any) => resp));
  }
}
